import { useTranslation } from 'react-i18next'
import { formatPercent } from '../../../lib/number'
import type { TaskOriginSplit } from '../types'

interface Props {
  split: TaskOriginSplit
}

/**
 * Statü listesinin **son öğesi** olarak doğrudan / toplantı bağımlı görev dağılımı (120): ince bir ayraç
 * ve tek satırlık iki değer ("Doğrudan Görev 18 (%13,2)"). Renk ve çubuk bilerek YOK — ilk hâldeki renkli
 * çubuk statülerle karışıyordu ve kalabalıktı (kullanıcı geri bildirimi 07.10.2026). Sayılar statü
 * halkasıyla aynı kümeden gelir; toplamı halkanın merkezindeki sayıdır (sunucu garanti eder).
 *
 * <p>Bir `<li>` döner: çağıran onu statü listesinin (`ul.home-dist-legend`) içine koyar.
 */
export default function TaskOriginSplitBar({ split }: Readonly<Props>) {
  const { t, i18n } = useTranslation()
  if (split.total === 0) return null

  const rows = [
    { key: 'direct', label: t('home.origin.direct'), count: split.direct, percent: split.directPercent },
    {
      key: 'meetingBound',
      label: t('home.origin.meetingBound'),
      count: split.meetingBound,
      percent: split.meetingBoundPercent,
    },
  ]

  return (
    <li className="home-origin">
      {rows.map((r) => (
        <div key={r.key} className="home-origin-row">
          <span className="home-origin-name">{r.label}</span>
          <span className="home-dist-count">{r.count}</span>
          <span className="home-dist-pct">(%{formatPercent(r.percent, i18n.language)})</span>
        </div>
      ))}
    </li>
  )
}
